var DateChecker = require('./DateChecker');
var DateNoTz = require('./DateNoTz');
var BookingDate = require('./BookingDate');

class Service { 
    constructor(constructorObject, serverDate, serverDateString){
        for(var key in constructorObject){
            this[key] = constructorObject[key];
        }
        this.serverDateString = serverDateString
        // this.serverDate = new DateFormattable(serverDate ? serverDate : new Date());
        this.availableBookingDates = null;
        this.unavailableEmptyBookingDates = null;
        this.leadPeriodEnd = null;

        // Set Default Values
        this.weekly_start_day = this.weekly_start_day || 1
        this.weekly_end_day = this.weekly_end_day || 5
    }

    /* 
        ---- DEV NOTE:
        If you are to modify or change any of the operations below, please do so in BookingDatesMixin instead
        Then, replacee these outdated filters with function calls to BookingDatesMixins
        - Franco Mapua
    */

    deriveAvailableBookingDates(availableBookingDates){
        var filteredBookingDates = []
        for (let i = 0; i < availableBookingDates.length; i++) {
            filteredBookingDates.push(new BookingDate(availableBookingDates[i]));
        }

        // Remove booking dates not assigned to this service
        filteredBookingDates = filteredBookingDates.filter(bookingDate =>{
            var bookingDate = new BookingDate(bookingDate);
            return bookingDate.hasService(this.api_value);
        })

         // Determine Lead Days
        var leadDays = this.booking_lead_day ? this.booking_lead_day : 0
        var bookingLeadWeekCount = this.book_lead_week ? this.book_lead_week : 0

        // Determine CutOff Time
        var now = new DateNoTz(this.serverDateString)
        var dayTodayShortDesc = now.getDayDesc().substring(0,3).toLowerCase()
        var todayCutOffTime = this[dayTodayShortDesc + "_cut_off"]
        let cutOffTime =  todayCutOffTime || this.booking_cutoff

        // Relocated dealration in a higher level
        const   today = now.getDayDesc();
        const   todayIsSaturday     = today == "Saturday",
                todayIsSunday       = today == "Sunday";

        // If currently booking on weekends. Ignore cutoff time
        cutOffTime = (todayIsSaturday || todayIsSunday) ? '23:59:59' : cutOffTime;

        // Filter by CutOff Time and Entitlements
        var dateChecker = new DateChecker();
        var cutoffIsTrue = !dateChecker.isDateTimeBeforeTime(this.serverDateString, cutOffTime)
        if(cutoffIsTrue){
            ++leadDays; 
        }

        // Get the start date if weekly
        filteredBookingDates = filteredBookingDates.map(bookingDate => {
            var purgeDay = bookingDate.date

            // Set the purge day to the start of the week
            // if(this.date_selection && this.date_selection.indexOf('week') > -1){
            //     var startDate = this.weekly_start_day
            //     var dateChecker = new DateChecker()
            //     var weekOfDate =  dateChecker.getWeekOfDate(bookingDate.date)
            //     purgeDay = weekOfDate[startDate]
            // }

            bookingDate.purgeDay = purgeDay
            return bookingDate
        })

        // Purge Days according to lead settings
        if(leadDays > 0 && bookingLeadWeekCount <= 0){
            // Purge days if there is a lead period
            
            var leadPeriodStart = new DateNoTz(this.serverDateString);
            var weekendShift = leadPeriodStart.dayNumber == 0 || leadPeriodStart.dayNumber == 6 ? (leadPeriodStart.dayNumber % 5) + 1 : 0 // Add + 2 to lead Days if Saturday, and + 1 if Sunday
            
            /*
                Stry: [HYP-18] Weekend booking set up
                Date: 2021-03-17
                Auth: Franco Mapua
                Desc: Adding new formatter for version 
            */
            // --- Determine Current Day
            let shiftGoesBackOneDay;

            if(todayIsSaturday){
                shiftGoesBackOneDay = this.saturday_booking_lead_target_day == 7
            }
            else if(todayIsSunday){
                shiftGoesBackOneDay = this.sunday_booking_lead_target_day == 7
            }
            if(shiftGoesBackOneDay && weekendShift > 0){
                weekendShift = weekendShift - 1
            }


            leadPeriodStart.shift(weekendShift)
            leadPeriodStart.setTime("00:00:00")
            var leadPeriodEnd = new DateNoTz(leadPeriodStart.dateString + ' ' + leadPeriodStart.timeString);
            leadDays--; // This is so because we consider "end of day" as one day, so leadDay = 1 is today 00:00 to today 23:59
            leadPeriodEnd.shiftDateWeekdaysOnly(leadDays)
            
            leadPeriodEnd.setTime("23:59:59")
            this.leadPeriodEnd = leadPeriodEnd

            var leadPeriodStartSeconds = leadPeriodStart.convertToSeconds()
            var leadPeriodEndSeconds = leadPeriodEnd.convertToSeconds()

            filteredBookingDates = filteredBookingDates.filter(bookingDate =>{
                var date = new DateNoTz(bookingDate.purgeDay);
                var dateSeconds = date.convertToSeconds()
                // var dateIsInLeadPeriod = leadPeriodStartSeconds <= dateSeconds && dateSeconds <= leadPeriodEndSeconds
                var dateIsInLeadPeriod = dateSeconds <= leadPeriodEndSeconds
                return !dateIsInLeadPeriod
            })
        }
        else if(bookingLeadWeekCount > 0){
            // Purge days for a lead week
            let cutOffDay = this.week_cut_off || 5 // Default to Friday
            cutOffTime = cutOffTime || "23:59:00" // Default to End Of Day
            var areLeadWeekSettingsComplete = (bookingLeadWeekCount && bookingLeadWeekCount != 0 && cutOffDay)
            if(areLeadWeekSettingsComplete){
                var blockOffPeriod = new DateChecker().getTimePeriodFromWeekSettings(this.serverDateString, bookingLeadWeekCount, cutOffDay, cutOffTime)
                filteredBookingDates = filteredBookingDates.filter(bookingDate =>{
                    var date = new Date(bookingDate.purgeDay);
                    return blockOffPeriod.containsDate(date) == false;
                })
            }
            
        }

        if (undefined != this.limit_available_dates && this.limit_available_dates != 0) {
            let serviceSetting = this;

            if (undefined != serviceSetting.end_of_financial_year && '' != serviceSetting.end_of_financial_year) {
                let limit = new Date(serviceSetting.end_of_financial_year + ' ' + new Date().getFullYear());
                limit.setHours(23);
                limit.setMinutes(59);
                limit.setSeconds(59);

                if (limit > new Date(now.printString)) {
                    filteredBookingDates = filteredBookingDates.filter(bookingDate => {
                        let filteredBookingDate = new Date(bookingDate.date);

                        if ((undefined != serviceSetting.allow_extended &&
                                    serviceSetting.allow_extended > 0) && 
                                undefined != serviceSetting.extended_date_limit
                            ) {
                            
                            startOfExtendedLimit = new Date(serviceSetting.end_of_financial_year + ' ' + new Date().getFullYear());

                            let i = 1;
                            while (i <= serviceSetting.allow_extended) {
                                startOfExtendedLimit.setDate(startOfExtendedLimit.getDate() - 1);
                                if (startOfExtendedLimit.getDay() != 0 && startOfExtendedLimit.getDay() != 6) {
                                    i++;
                                }
                            }

                            if (startOfExtendedLimit <= new Date(now.printString)) {
                                let extendedDateLimit = new Date(serviceSetting.extended_date_limit + ' ' + new Date().getFullYear());

                                limit.setDate(extendedDateLimit.getDate());
                                limit.setMonth(extendedDateLimit.getMonth());
                                limit.setFullYear(extendedDateLimit.getFullYear());
                            }
                        }

                        return filteredBookingDate <= limit;
                    });
                } else if (limit < new Date(now.printString)) {
                    limit.setFullYear(limit.getFullYear() + 1);

                    filteredBookingDates = filteredBookingDates.filter(bookingDate => {
                        let filteredBookingDate = new Date(bookingDate.date);
                        return filteredBookingDate <= limit;
                    });
                }
            }
        }

        this.availableBookingDates = filteredBookingDates;
        return filteredBookingDates
    }
    /**
     * 2021-05-06
     * Author:  Joseph
     * Desc:    
     */
    findAlreadyBookedNearestDate(availableEntitledDates, selectedBookingProducts) {
        if (selectedBookingProducts.length === 0) return [0, null]

        let recentlyBookedWaste = null;
        let unavailableEmptyBookingDatesFiltered = this.unavailableEmptyBookingDates;

        if (this.leadPeriodEnd) {
            // Filter dates with zero avail. booking starting on end of lead period
            unavailableEmptyBookingDatesFiltered = this.unavailableEmptyBookingDates.filter(unavailable =>
                unavailable.date > this.leadPeriodEnd.dateString
            )
        }

        const toUnselectWastes = [];
        selectedBookingProducts.forEach(product => {
            // Booking dates with zero booking availability. Filter on date of this current iterating waste
            const previousBookedDatesOfProduct      =   unavailableEmptyBookingDatesFiltered.filter(
                unavailable => unavailable.wasteStreams.indexOf(`${product.apiValue}`) > -1
            )
            
            // Avail. Boooking dates. Filter on dates of this current iterating waste
            const availableBookingDatesOfProduct    =   availableEntitledDates.filter(bookingDate =>
                bookingDate.wasteStreams.filter(
                    waste => waste.wasteStreamApiValue === product.apiValue
                ).length > 0
            )

            // Check previous booked waste dates if it's the NEAREST one of all avail. booking dates to come
            previousBookedDatesOfProduct.forEach(unavailable => {
                // All available booking dates are future dates and we only booked successfully the NEAREST one
                const isNearestDateBooked = availableBookingDatesOfProduct.every(bookingDate =>
                    bookingDate.wasteStreams.filter(waste =>
                        `${waste.serviceApiValue}-${waste.wasteStreamApiValue}` === unavailable.wasteStreams
                    ) && bookingDate.date > unavailable.date
                )

                if (isNearestDateBooked) {
                    // disabllow to select this waste because there's a previous NEAREST booked dates of this waste!
                    toUnselectWastes.push(product)
                }
            })
        })

        /**
        *
        [{
            availableBookings: string
            bookingGrouping: string
            bookingLimit: string
            date: string
            purgeDay: string
            wasteStreams:
                [
                    {
                        serviceApiValue: string
                        wasteStreamApiValue: string
                    }
                ]
        }]
        */
       
        // availableEntitledDates = availableEntitledDates.filter
        //     (bookingDate => {
        //     const remainedWastes = bookingDate.wasteStreams.filter
        //         (waste => {
        //         // Find in unavailableEmptyBookingDates if same waste exist there bcoz the address ALREADY booked the nearest avail. date
        //         const hasUnavailableEmptyBookingDatesOfWaste = unavailableEmptyBookingDatesFiltered.find
        //             (unavailable => unavailable.wasteStreams.indexOf(`${waste.serviceApiValue}-${waste.wasteStreamApiValue}`) > -1 && unavailable.date <= bookingDate.date )

        //         // const recentBookedWastes = unavailableEmptyBookingDatesFiltered.filter
        //         //     (unavailable => unavailable.wasteStreams.indexOf(`${waste.serviceApiValue}-${waste.wasteStreamApiValue}`) > -1 )

        //         // if (recentBookedWastes.length > 0)
        //         //     {
        //         //     if (recentBookedWastes.filter(unavailable => ))
        //         //         {

        //         //         }
        //         //     }

        //         // If found, means the available booking credit of the booking date has been acquired already
        //         if (hasUnavailableEmptyBookingDatesOfWaste)
        //             {
        //             // Find/Remember the product that has recorded previous booking
        //             recentlyBookedWaste = selectedBookingProducts.find(product => product.apiValue === waste.wasteStreamApiValue);
        //             }

        //         // Means, filter only if available booking credit of the booking date isn't used yet
        //         return !hasUnavailableEmptyBookingDatesOfWaste
        //         })

        //     return remainedWastes.length > 0
        //     })

        return [availableEntitledDates, toUnselectWastes];
    }
}

module.exports = Service